
import { defineComponent, computed } from 'vue'
import { ItemSpec } from '@/lib/item-spec'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    itemName: {
      type: String,
      required: true
    }
  },
  setup (props) {
    const { t } = useI18n()

    const headers = computed(() => ItemSpec.sizeTable(props.itemName).headers)
    const sizes = computed(() => ItemSpec.sizeTable(props.itemName).body)

    return { t, headers, sizes }
  }
})
